import { render } from "./goodrx-comparison-links.vue?vue&type=template&id=953ad8aa&ts=true"
import script from "./goodrx-comparison-links.vue?vue&type=script&lang=ts"
export * from "./goodrx-comparison-links.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__